import script from "./CareerDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerDetailComponent.vue?vue&type=script&setup=true&lang=js"

import "./CareerDetailComponent.vue?vue&type=style&index=0&id=515fff67&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-515fff67"]])

export default __exports__